import React from 'react'
import BaseIcon from 'react-icon-base'

const TH = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>TH</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFB700" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <path fill="#ED1C24" d="M-.963.037h22.388v14.925H-.963z" />
        <path fill="#FFF" d="M-.963 2.525h22.388v9.95H-.963z" />
        <path fill="#241D4F" d="M-.963 5.012h22.388v4.975H-.963z" />
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default TH
